module.exports = __webpack_public_path__ + "static/img/folder.0c8b4601.png";